import React from "react";

export interface PageLabelPropsType {
  text?: string;
  fontSize?: string;
  fontWeight?: string;
  fontColor?: string;
  marginBottom?: string;
}

function PageLabel({
  text,
  fontSize = "default",
  fontWeight = "semibold",
  fontColor = "default",
  marginBottom = "medium",
}: PageLabelPropsType): React.JSX.Element {
  return (
    <div
      className={`fe_u_margin--bottom-${marginBottom} fe_u_font-size--${fontSize} fe_u_font-weight--${fontWeight} fe_u_color--${fontColor}`}
    >
      {text}
    </div>
  );
}

export default PageLabel;
